import config from "../../config";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Head from "next/head";

import VideoCardSmallCollection from "../../components/VideoCardSmallCollection";
import HeaderExtension from "../../components/HeaderExtension";

function All({ projects, years, weeks }) {
  return (
    <div className="bg-gray-100 relative w-full h-full min-h-screen">
      <Head>
        <title>Automate.video | Directory</title>
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Header />
      <HeaderExtension title={"All Videos"} />
      <div className="container relative px-2 mx-auto  pb-24 mt-24 w-full min-h-screen ">
        {projects ? (
          <div className=" w-full h-full mb-4 ">
            <h3 style={{ color: "#8892a8" }} className="w-full justify-start text-2xl  font-bold  mt-1  mb-3  ">
              Latest
            </h3>
            <VideoCardSmallCollection projects={projects} />
          </div>
        ) : null}
        <div className="flex flex-row w-full items-center mb-40  ">
          {years.map((y) => {
            return (
              <div key={y} className=" w-full ">
                <h3 style={{ color: "#8892a8" }} className="w-full justify-start text-2xl  font-bold mt-1  mb-3  ">
                  {y}
                </h3>
                <span className="mr-2">Week:</span>{" "}
                {weeks.map((w) => {
                  if (w.year_cat === y)
                    return (
                      <a key={y + w.week_cat} href={`/directory/year/${y}/week/${w.week_cat}`} className="mr-2">
                        {w.week_cat}
                      </a>
                    );
                  else return null;
                })}
              </div>
            );
          })}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export async function getStaticProps({ params }) {
  const delay = require("delay");
  // params contains the post `id`.
  // If the route is like /posts/1, then params.id is 1
  const res = await fetch(`${config.socketIo}/api/getLatestPublicProjects`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ limit: 50 }),
  });
  console.log(JSON.stringify(res));
  let projectdata = [];
  if (res.status !== 404) projectdata = await res.json();

  let width = 200;
  let height = 111;
  let playIcon = true;
  // this logic + calling the whole getVideoThumbnail should be a library logic, now replicate from here everywhere needed
  // create thumbnail filename, attribute name
  let thumbnailName = "thumbnail_w" + width + "h" + height + (playIcon ? "pT" : "pF");

  let projects = [];
  for (let d of projectdata) {
    // check if thumbnail previously created, if yes, use overwrite
    let previewImageUrl = null;
    if (d.urls?.[thumbnailName]) previewImageUrl = d.urls[thumbnailName];

    if (!previewImageUrl) {
      await delay(100);
      const thumbnailres = await fetch(
        config.mediacache + "/api/cache-getVideoThumbnail?mode=url&width=200&height=111&projectid=" + d.projectid,
        {
          retries: 7,
          retryDelay: 1000,
        }
      );

      try {
        const thumbnailjson = await thumbnailres.json();
        previewImageUrl = thumbnailjson.url;
      } catch (err) {
        console.warn("did not get videoThumbnail for " + d.projectid);
      }
    }

    projects.push({
      projectid: d.projectid,
      projectUrl: "/" + d.projectid,
      name: d.name,
      previewImageUrl: previewImageUrl,
      created: d.created,
    });
  }

  const res2 = await fetch(`${config.socketIo}/api/getPublicProjectsWeeklyCategories`);

  const weeks = await res2.json();
  let years = [];
  for (let d of weeks) if (years.indexOf(d.year_cat) === -1) years.push(d.year_cat);

  //console.log(projects);

  // Pass post data to the page via props
  return { props: { projects, years: years, weeks: weeks }, revalidate: 600 };
}

export default All;
